
import { Component, Prop, Vue } from "vue-property-decorator";
import { validationRules } from "@/constants/ValidationRules";

@Component({})
export default class AeTextarea extends Vue {
  @Prop({ default: null })
  value!: unknown;

  @Prop({ default: null })
  label!: string;

  @Prop({ default: false })
  required!: boolean;

  @Prop({ default: false })
  disabled!: boolean;

  rules: unknown[] = [];

  mounted(): void {
    if (this.required) {
      this.rules.push(validationRules.required);
    }
  }

  update(newValue: string): void {
    this.$emit("input", newValue);
  }

  validityChanged(isInvalid: boolean) {
    this.$emit("validityChanged", !isInvalid);
  }
}
